import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
@Injectable({
  providedIn: 'root'
})
export class FinancialService {

  constructor(private http: HttpClient,private env:EnvironmentService) {
  }


  getDepositWalletAccounts(usertType: string, userId: string): Observable<unknown> {
    const envValue:any = this.env.getEnvironment();
    return this.http.get(envValue.baseUrl + envValue.wso2amEndPoint+ "/rvm" + envValue.wso2amApiVersion +"/api/v1/rvm/deposit/prepaid", 
    {params: {
        user_id : userId,
        user_type : usertType
    }}
    )
  }
}
